import { RefObject, useEffect } from "react";

const NON_PASSIVE_EVENT_OPTIONS: AddEventListenerOptions = { passive: false };

export function useCropperTouchGuard(frameRef: RefObject<HTMLDivElement>, isActive: boolean) {
  useEffect(() => {
    const frame = frameRef.current;
    if (!frame || !isActive) return;

    const preventNativeGesture = (event: Event) => event.preventDefault();
    const events = ["touchstart", "touchmove", "gesturestart", "gesturechange"];

    events.forEach((eventName) =>
      frame.addEventListener(eventName, preventNativeGesture, NON_PASSIVE_EVENT_OPTIONS)
    );

    return () => {
      events.forEach((eventName) =>
        frame.removeEventListener(eventName, preventNativeGesture, NON_PASSIVE_EVENT_OPTIONS)
      );
    };
  }, [frameRef, isActive]);
}
